import React from 'react';
import { Button } from 'semantic-ui-react';
import CreateButton from '@/components/buttons/CreateButton';
import RemoveButton from '@/components/buttons/RemoveButton';

const FormObjectsFormButtons = ({
  allowAdd,
  allowRemove,
  deleteItem,
  entity = 'catalogue.object',
  field,
  insertItem,
}) => (
  <Button.Group
    icon
    compact
    floated="right"
    size="small"
    className="aridhia-form-objects-form-buttons"
  >
    <CreateButton disabled={!allowAdd} entity={entity} onClick={insertItem} text={field?.placeholder} />
    <RemoveButton disabled={!allowRemove} entity={entity} onClick={deleteItem} />
  </Button.Group>
);

export default FormObjectsFormButtons;
